<p-table [value]="listCancelationsOfUser" styleClass="p-datatable" id="table_payments">
  <ng-template pTemplate="header">
    <tr>
      <th>Fecha</th>
      <th>Monto</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-payments>
    <tr>
      <td>
        <div class="datatable__info">
          <p>{{payments.date | date: 'short'}}</p>
        </div>
      </td>
      <td>
        <div class="datatable__value">
          <p>{{payments.amount | currency}}</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
